

define(['squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-models/src/user/index'], function (squid, template) {

    squid.module('xo-merchant-header.directive', ['squid', 'xomodel.checkout', 'xomodel.user']).directive('xoMerchantHeader', function () {
        return {
            template: template,

            restrict: 'E',

            scope: {
                token: '=',
                merchant: '='
            },

            controller: function controller($scope, $populate, $config, $CheckoutAppDataModel, $CheckoutInputDataModel) {
                if ($config.flow !== 'shoppingcart' && !$CheckoutInputDataModel.instance($scope.token).isEbayTxn()) {
                    // show the merchant header only for non-ebay flows
                    $populate($scope, {
                        checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
                    }).then(function () {
                        $scope.merchant = $scope.checkoutAppData.merchant;
                    });
                }
            }
        };
    }).directive('xoMerchantImageResize', function () {
        return {
            restrict: 'A',

            link: function link(scope, element, attributes) {
                element.bind('load', function (event) {
                    var maxWidth = 780;
                    var maxHeight = 90;
                    var height = 90;
                    var ratio = 0;

                    if (this.width > maxWidth) {
                        ratio = maxWidth / this.width;
                        this.width = maxWidth;
                        height = this.height * ratio;
                        this.height = height > maxHeight ? maxHeight : height;
                    }
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/merchant-header/directive.js
// module id = ./components/xo-page-components/src/merchant-header/directive.js
// module chunks = 1